import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import pdf from '../../Images/icons/doc.png'
import layoutBgImg from '../../Images/layout/sale.jpg'
import { GetDocumentSample } from '../../api/Queries/get'
import { Context } from '../../Store/context'
import Loading from '../../Component/loader/loader'
import GlobalLayout from '../../Component/layout/global-layout'
import { Link } from 'react-router-dom'

const DocumentSampleList = () => {
    const [document, setDocument] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    const getPdfUrl = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    useEffect(() => {
        setIsLoading(true)
        const getDocumentSample = async () => {
            try {
                const data = await GetDocumentSample()
                setIsLoading(false)
                setDocument(data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getDocumentSample()
    }, [showError])

    return (
        <GlobalLayout
            title={`${t('document_sample')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Образцы документов, Resminamalaryň nusgalary, Resminama nusgalary"
        >
            <div className='mb-20'>
                <Layout
                    title={t('document_sample')}
                    layoutBgImg={layoutBgImg}
                />
                <div className='mt-8 media'>
                    <ul className='py-8 px-8 bg-white dark:bg-dark-border'>
                        <p className='text-xl text-primary dark:text-dark-text font-bold'>
                            {t('document_sample')}
                        </p>
                        {isLoading ? <Loading /> :
                            document?.map((d) => (
                                <li className='bg-gray dark:bg-dark-box dark:text-dark-text 
                                               flex justify-between items-center p-4 my-4'
                                    key={d.id}
                                >
                                    <Link to={`/document-sample-list/${d.id}`}>
                                        {getLawName(d)}
                                    </Link>
                                    <a
                                        href={getPdfUrl(d)}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={pdf} alt="PDF" width='32' />
                                    </a>
                                </li>
                            ))}
                        {isLoading ? '' : document.length === 0 && ''}
                    </ul>
                </div>
            </div>
        </GlobalLayout>
    )
}

export default DocumentSampleList